// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__S78NE","notes":"Notes_notes__3Wx34","note":"Notes_note__2zapi","markdown":"Notes_markdown__WuVkx"};